/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'
import { Link } from 'gatsby';

const PostLink = ({ link, title, category, date }) => {
  return (
    <Flex as="div" sx={{ flexDirection: "column", marginBottom: 12}}>
      <h3 sx={{margin: 0}}>{category}</h3>
      <span sx={{ fontSize: 14 }}>{date}</span>

      <Link to={link} sx={{
        textDecoration: 'none',
        color: '#2a7ae2',
        fontSize: 24,
        '&:hover': {
          textDecoration: 'underline',
        }
      }}>
        {title}
      </Link>
    </Flex>
  )
}

export default PostLink;